import Box from "@material-ui/core/esm/Box";
import DeleteIcon from "@material-ui/icons/esm/DeleteOutline";
import CachedIcon from "@material-ui/icons/esm/Cached";
import VehicleIcon from "@material-ui/icons/esm/DirectionsCarOutlined";
import DownloadIcon from "@material-ui/icons/esm/GetApp";
import CancelIcon from "@material-ui/icons/esm/Cancel";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { SecondaryButton } from 'components/Button';
import { Header, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import useExportObes from 'hooks/obe/useExportObes';
import { REGISTER_VEHICLE } from 'routes/overview/RegisterVehicle/paths';
import { TERMINATE_INACTIVE_TAG_EXACT } from 'routes/overview/TerminateInactiveTag/paths';
import { TRANSFER } from 'routes/overview/TransferTag/paths';
import { UNREGISTER } from 'routes/overview/UnregisterTag/paths';
import useStyles from './AgreementStyles';
export default function GetStarted() {
  const {
    sectionGetStarted,
    vehicleButtons
  } = useStyles();
  const {
    push
  } = useHistory();
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const {
    downloadObeDetails,
    downloadIsLoading
  } = useExportObes();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    className: sectionGetStarted
  }, /*#__PURE__*/React.createElement(Header, {
    hasNoSpacing: true
  }, t('titles.vehicles_and_tag')), /*#__PURE__*/React.createElement(Title, null, t('agreements.choices_for_tags_and_vehicles')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: vehicleButtons,
    onClick: () => push(TRANSFER),
    startIcon: /*#__PURE__*/React.createElement(CachedIcon, null)
  }, t('agreements.transfer_a_tag')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: vehicleButtons,
    onClick: () => push(REGISTER_VEHICLE),
    startIcon: /*#__PURE__*/React.createElement(VehicleIcon, null)
  }, t('agreements.register_new_vehicle')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: vehicleButtons,
    onClick: () => push(UNREGISTER),
    startIcon: /*#__PURE__*/React.createElement(DeleteIcon, null)
  }, t('agreements.remove_a_vehicle')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: vehicleButtons,
    onClick: () => push(TERMINATE_INACTIVE_TAG_EXACT),
    startIcon: /*#__PURE__*/React.createElement(CancelIcon, null)
  }, t('terminate_inactive_tag.title')), /*#__PURE__*/React.createElement(SecondaryButton, {
    className: vehicleButtons,
    loading: downloadIsLoading,
    disabled: !customer?.id,
    onClick: () => downloadObeDetails(customer?.id),
    startIcon: /*#__PURE__*/React.createElement(DownloadIcon, null)
  }, t('agreements.export_obes'))));
}